import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import BM from '../../models/gallery.model';
import '../../utils/swiper.util';

interface bannerProps {
  banners: BM,
  home?: boolean
}
const Banner: React.FC<bannerProps> = props => {

  const { banners, home } = props;

  return (
    <Swiper
      observeParents={true}
      observer={true}
      loop={true}
      slidesPerView={1}
      autoplay={{
        disableOnInteraction: false
      }}
      navigation
      pagination={{ clickable: true }}
      className="ecn-banner"
    >
      {
        banners && banners.children && banners.children.length ?
          banners?.children?.map(banner => (
            <SwiperSlide key={banner.id}>
              <div className={`ecn-home-banner ${home ? 'home' : ''}`} >
                <figure>
                  <img src={banner.value} alt={banner.key} />
                  <figcaption>
                    {banner.name}
                  </figcaption>
                </figure>
              </div>
            </SwiperSlide>
          )) : ""
      }
    </Swiper>
  );
}

export default Banner;